import React, { Component, ErrorInfo, ReactNode } from 'react';
import { Button } from 'primereact/button';
import { Card } from 'primereact/card';

interface Props {
  children: ReactNode;
}

interface State {
  hasError: boolean;
  error: Error | null;
  errorInfo: ErrorInfo | null;
}

class ErrorBoundary extends Component<Props, State> {
  public state: State = {
    hasError: false,
    error: null,
    errorInfo: null,
  };

  public static getDerivedStateFromError(_: Error): State {
    return { hasError: true, error: null, errorInfo: null };
  }

  public componentDidCatch(error: Error, errorInfo: ErrorInfo) {
    console.error('Uncaught error:', error, errorInfo);
    this.setState({ error, errorInfo });
  }

  private handleReload = () => {
    window.location.reload();
  };

  public render() {
    if (this.state.hasError) {
      return (
        <div className="p-d-flex p-jc-center p-ai-center" style={{ minHeight: '100vh' }}>
          <Card className="p-shadow-4" style={{ maxWidth: '600px' }}>
            <h2 className="p-text-center">Oops! Something went wrong.</h2>
            <p className="p-text-center">
              {this.state.error?.message || 'An unexpected error occurred.'}
            </p>
            {process.env.NODE_ENV === 'development' && this.state.errorInfo && (
              <pre className="p-mt-3 p-mb-3" style={{ overflow: 'auto', maxHeight: '200px' }}>
                {this.state.errorInfo.componentStack}
              </pre>
            )}
            <div className="p-d-flex p-jc-center">
              <Button label="Reload Page" icon="pi pi-refresh" onClick={this.handleReload} />
            </div>
          </Card>
        </div>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;